module.exports = __webpack_public_path__ + "img/pc-doc.b67e88cf.svg";